<template>
  <v-checkbox
    style="
      max-width: max-content;
      max-height: 24px;
      overflow: hidden;
      display: flex;
      align-items: center;
    "
    class="custom-input"
    density="compact"
    :disabled="disabled"
    :modelValue="modelValue"
    @update:modelValue="(val) => $emit('update:modelValue', val)"
    :true-value="trueValue"
    :false-value="falseValue"
    true-icon="mdi-close-box-outline"
    false-icon="mdi-checkbox-blank-outline"
    hide-details
    @click="$emit('click', $event)"
  >
    <template #label>
      <span></span> <!-- Removes default label text -->
    </template>
  </v-checkbox>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: [Boolean, Number, String],
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  trueValue: {
    type: [Boolean, Number, String],
    default: true,
  },
  falseValue: {
    type: [Boolean, Number, String],
    default: false,
  }
});

defineEmits<{
  (e: 'update:modelValue', ...args: any[]): void;
  (e: 'click', ...args: any[]): void
}>();
</script>

<style scoped>
/* Any additional custom styling can go here */
</style>